import { bool, func, string, object } from "prop-types";
import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { useEstimateStructure } from "@tools";
import { getTimelineSegmentWidth } from "@tools/EstimateEditor/utils";
import { Grid } from "@material-ui/core";
import { TimelineChartBar } from "../TimelineChartBar/TimelineChartBar";

export const TimelineUtilizationChart = observer(({
  workTypeId,
  teamMemberId,
  name,
  color,
  fontColor,
  expandable,
  expanded,
  onExpand,
}) => {
  const structure = useEstimateStructure();
  const {
    maxTimelineEndDate,
    timelineExpandedMonths,
    timelineStartDate,
  } = structure.settings;

  const blocks = structure.currentTimeline?.getUtilizationChartBlocks(
    workTypeId,
    teamMemberId,
  ) || [];

  const { width, bars } = (() => {
    const bars = blocks.map((block) => {
      const { offsetLeft, offsetRight, width: barWidth } = getTimelineSegmentWidth({
        startDate: block.startDate,
        endDate: block.endDate,
        expandedMonths: timelineExpandedMonths,
        includeLastDay: true,
      });

      return {
        ...block,
        exceeds: block.endDate > maxTimelineEndDate,
        barLeft: getTimelineSegmentWidth({
          startDate: timelineStartDate,
          endDate: block.startDate,
          expandedMonths: timelineExpandedMonths,
          isFirstTimelineMonth: true,
        }).width,
        barWidth, offsetLeft, offsetRight,
      }
    });

    const lastBar = bars[bars.length-1];

    return {
      width: lastBar ? lastBar.barLeft + lastBar.barWidth : 0,
      bars,
    };
  })();

  return (
    <Grid
      item container
      alignItems="center"
      style={{ width }}
      className="relative"
    >
      {bars.map((bar, index) => (
        <TimelineChartBar
          key={`${getDateKey(bar.startDate)}-${getDateKey(bar.endDate)}`}
          color={color}
          fontColor={fontColor}
          label={index === 0 ? name : undefined}
          expandable={expandable}
          expanded={expanded}
          onExpand={onExpand}
          height="medium"
          weight={bar.weight}
          exceeds={bar.exceeds}
          barLeft={bar.barLeft}
          barWidth={bar.barWidth}
          className="absolute"
        />
      ))}
    </Grid>
  );
});

TimelineUtilizationChart.propTypes = {
  workTypeId: string.isRequired,
  teamMemberId: string,
  name: string,
  color: string.isRequired,
  fontColor: string,
  expandable: bool,
  expanded: bool,
  onExpand: func,
  blocksStartDate: object,
};
